import { NgModule } from '@angular/core';
import { Route, RouterModule, Routes } from '@angular/router';
import { ChooseALabComponent } from '@components/choose-a-lab/choose-a-lab.component';
import { ConsultAttachmentComponent } from '@components/consultation-request/consult-attachment/consult-attachment.component';
import { ConsultationNavigationRestrictedErrorComponent } from '@components/consultation-request/consultation-navigation-restricted-error/consultation-navigation-restricted-error.component';
import { ConsultationRequestPageComponent } from '@components/consultation-request/consultation-request-page/consultation-request-page.component';
import { ConsultationSubmissionErrorComponent } from '@components/consultation-request/consultation-submission-error/consultation-submission-error.component';
import { ConsultationUpsellPaymentCardComponent } from '@components/consultation-request/consultation-upsell-payment-card/consultation-upsell-payment-card.component';
import { MensIntimateWashSwitcherComponent } from '@components/consultation-request/upsells/mens-intimate-wash/switcher/mens-intimate-wash-switcher.component';
import { ReplenishYourGoodBacteriaSwitcherComponent } from '@components/consultation-request/upsells/replenish-your-good-bacteria/switcher/replenish-your-good-bacteria-switcher.component';
import { SofterStoolsComponent } from '@components/consultation-request/upsells/softer-stools/softer-stools.component';
import { CookiesDisabledComponent } from '@components/cookies-disabled/cookies-disabled.component';
import { DoxyPEPComponent } from '@components/doxy-pep/doxy-pep.component';
import { EdTreatmentComponent } from '@components/ed-treatment/ed-treatment.component';
import { FemaleCondomComponent } from '@components/female-condom/female-condom.component';
import { MycoplasmaGenitaliumComponent } from '@components/mycoplasma-genitalium/mycoplasma-genitalium.component';
import { MycoplasmaHominisUreaplasmaComponent } from '@components/mycoplasma-hominis-ureaplasma/mycoplasma-hominis-ureaplasma.component';
import { NullComponent } from '@components/null/null.component';
import { OrderComponent } from '@components/order/order.component';
import { OrderAddressComponent } from '@components/order-address/order-address.component';
import { OrderBetterLabComponent } from '@components/order-better-lab/order-better-lab.component';
import { OrderCompleteComponent } from '@components/order-complete/order-complete.component';
import { PartialResultsDeliveryComponent } from '@components/partial-results-delivery/partial-results-delivery.component';
import { ScheduleConsultationComponent } from '@components/schedule-consultation/schedule-consultation.component';
import { AlleviateNauseaAndVomitingSwitcherComponent } from '@consultation-upsells/alleviate-nausea-and-vomiting/switcher/alleviate-nausea-and-vomiting-switcher.component';
import { AzelaicAcidComponent } from '@consultation-upsells/azelaic-acid/azelaic-acid.component';
import { BePreparedForTheUnexpectedComponent } from '@consultation-upsells/be-prepared-for-the-unexpected/be-prepared-for-the-unexpected.component';
import { BiotinComponent } from '@consultation-upsells/biotin/biotin.component';
import { ClotrimazoleVaginalCreamComponent } from '@consultation-upsells/clotrimazole-vaginal-cream/clotrimazole-vaginal-cream.component';
import { ComprehensiveHealthPanelComponent } from '@consultation-upsells/comprehensive-health-panel/comprehensive-health-panel.component';
import { ExpeditedShippingComponent } from '@consultation-upsells/expedited-shipping/expedited-shipping.component';
import { FiberSupplementComponent } from '@consultation-upsells/fiber-supplement/fiber-supplement.component';
import { FollowUpStdTestComponent } from '@consultation-upsells/follow-up-std-test/follow-up-std-test.component';
import { HairGrowthComponent } from '@consultation-upsells/hair-growth/hair-growth.component';
import { HairLossTreatmentComponent } from '@consultation-upsells/hair-loss-treatment/hair-loss-treatment.component';
import { MaximizeYourGlp1ResultsComponent } from '@consultation-upsells/maximize-your-glp-1-results/maximize-your-glp-1-results.component';
import { MedicationPickupDeliveryComponent } from '@consultation-upsells/medication-pickup-delivery/medication-pickup-delivery.component';
import { MetforminSwitcherComponent } from '@consultation-upsells/metformin/switcher/metformin-switcher.component';
import { NeedADoctorsNoteComponent } from '@consultation-upsells/need-a-doctors-note/need-a-doctors-note.component';
import { PeptideTherapySwitcherComponent } from '@consultation-upsells/peptide-therapy/switcher/peptide-therapy-switcher.component';
import { PriorityProcessingComponent } from '@consultation-upsells/priority-processing/priority-processing.component';
import { RelieveOutbreakPainComponent } from '@consultation-upsells/relieve-outbreak-pain/relieve-outbreak-pain.component';
import { SexualPerformanceSwitcherComponent } from '@consultation-upsells/sexual-performance/switcher/sexual-performance-switcher.component';
import { Spf50Sunscreen } from '@consultation-upsells/spf50-sunscreen/spf50-sunscreen';
import { TestosteroneTherapyComponent } from '@consultation-upsells/testosterone-therapy/testosterone-therapy.component';
import { VaginalCreamComponent } from '@consultation-upsells/vagnial-cream/vaginal-cream.component';
import { VitaminB12Component } from '@consultation-upsells/vitamin-b12/vitamin-b12.component';
import { VitaminDSupplementSwitcherComponent } from '@consultation-upsells/vitamin-d-supplement/switcher/vitamin-d-supplement-switcher.component';
import { WellnessPanelComponent } from '@consultation-upsells/wellness-panel/wellness-panel.component';
import { YeastInfectionPreventionComponent } from '@consultation-upsells/yeast-infection-prevention/yeast-infection-prevention.component';
import { ZincSupplementComponent } from '@consultation-upsells/zinc-supplement/zinc-supplement.component';
import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { MycoplasmaTypes } from '@enums/mycoplasma-types';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { AgeRestrictedUpsellGuard } from '@guards/age-restricted-upsell-guard';
import { BetterLabGuard } from '@guards/better-lab.guard';
import { BusinessAccountUpsellGuard } from '@guards/business-account-upsell.guard';
import { ConsultationPharmacyStateGuard } from '@guards/consultation-pharmacy-state.guard';
import { ConsultationRequestCompletedGuard } from '@guards/consultation-request-completed.guard';
import { ConsultationRequestSessionGuard } from '@guards/consultation-request-session.guard';
import { ConsultationUpsellGuard } from '@guards/consultation-upsell.guard';
import { ConsultationUpsellPaymentGuard } from '@guards/consultation-upsell-payment.guard';
import { EdTreatmentGuard } from '@guards/ed-treatment.guard';
import { FemaleCondomGuard } from '@guards/female-condom.guard';
import { GenderRestrictedGuard } from '@guards/gender-restricted-guard';
import { MycoplasmaUpsellGuard } from '@guards/mycoplasma-upsell.guard';
import { OrderGuard } from '@guards/order.guard';
import { OrderAddressGuard } from '@guards/order-address.guard';
import { OrderCompleteGuard } from '@guards/order-complete.guard';
import { ParamHashGuard } from '@guards/param-hash.guard';
import { ParamTransactionIdGuard } from '@guards/param-transaction-id.guard';
import { PartialResultsDeliveryGuard } from '@guards/partial-results-delivery.guard';
import { RecentMenstruationRequiredGuard } from '@guards/recent-menstruation-required.guard';
import { SkipHasUpsellGuard } from '@guards/skip-has-upsell-guard';
import { StoreTreatmentTypeQueryParamGuard } from '@guards/store-treatment-type-query-param.guard';
import { TransactionIdGuard } from '@guards/transaction-id.guard';
import { VaginalCreamAllowedGuard } from '@guards/vaginal-cream-allowed-guard.service';
import { WhitelistGuard } from '@guards/whitelist.guard';
import { ConsultationRequestResolver } from '@resolvers/consultation-request.resolver';

/**
 * Routes module that will map all routes with the appropriate layouts or child layouts
 */
const routes: Routes = [
  {
    path: 'null',
    component: NullComponent,
    pathMatch: 'full',
  },
  {
    path: 'order',
    component: OrderComponent,
    pathMatch: 'full',
    canActivate: [OrderGuard, StoreTreatmentTypeQueryParamGuard],
  },
  {
    path: 'order-address.php',
    component: OrderAddressComponent,
    pathMatch: 'full',
    canActivate: [TransactionIdGuard, OrderAddressGuard],
  },
  {
    path: 'order-complete.php',
    component: OrderCompleteComponent,
    pathMatch: 'full',
    canActivate: [OrderCompleteGuard],
  },
  {
    path: 'betterlab.php',
    component: OrderBetterLabComponent,
    pathMatch: 'full',
    canActivate: [BetterLabGuard],
  },
  {
    path: 'choose-a-lab',
    component: ChooseALabComponent,
    pathMatch: 'full',
    canActivate: [ParamTransactionIdGuard, ParamHashGuard],
  },
  {
    path: ':treatmentType/consultation-request-completed',
    component: NullComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestCompletedGuard],
  },
  {
    path: 'consultation/schedule-consultation',
    component: ScheduleConsultationComponent,
    pathMatch: 'full',
  },
  {
    path: 'consultation/medication-pickup-or-delivery',
    component: MedicationPickupDeliveryComponent,
    pathMatch: 'full',
    canActivate: [
      ConsultationRequestSessionGuard,
      GenderRestrictedGuard,
      ConsultationUpsellGuard,
      ConsultationPharmacyStateGuard,
    ],
  },
  {
    path: 'consultation/upload-consult-attachments',
    component: ConsultAttachmentComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard],
  },
  {
    path: 'doxy-pep-treatment',
    component: DoxyPEPComponent,
    pathMatch: 'full',
    canActivate: [TransactionIdGuard, BusinessAccountUpsellGuard],
  },
  {
    path: 'partial-results-delivery',
    component: PartialResultsDeliveryComponent,
    pathMatch: 'full',
    canActivate: [TransactionIdGuard, BusinessAccountUpsellGuard, PartialResultsDeliveryGuard],
  },
  {
    path: 'mycoplasma-genitalium',
    component: MycoplasmaGenitaliumComponent,
    pathMatch: 'full',
    canActivate: [TransactionIdGuard, BusinessAccountUpsellGuard, MycoplasmaUpsellGuard],
    data: { mycoplasmaType: MycoplasmaTypes.Genitalium },
  },
  {
    path: 'mycoplasma-hominis-ureaplasma',
    component: MycoplasmaHominisUreaplasmaComponent,
    pathMatch: 'full',
    canActivate: [TransactionIdGuard, BusinessAccountUpsellGuard, MycoplasmaUpsellGuard],
    data: { mycoplasmaType: MycoplasmaTypes.HominisUreaplasma },
  },
  {
    path: 'female-condom',
    component: FemaleCondomComponent,
    pathMatch: 'full',
    canActivate: [TransactionIdGuard, BusinessAccountUpsellGuard, FemaleCondomGuard],
  },
  {
    path: 'ed-treatment',
    component: EdTreatmentComponent,
    pathMatch: 'full',
    canActivate: [TransactionIdGuard, BusinessAccountUpsellGuard, EdTreatmentGuard],
  },
  {
    path: 'consultation/yeast-infection-prevention',
    component: YeastInfectionPreventionComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/alleviate-nausea-and-vomiting',
    component: AlleviateNauseaAndVomitingSwitcherComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/replenish-your-good-bacteria',
    component: ReplenishYourGoodBacteriaSwitcherComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/mens-intimate-wash',
    component: MensIntimateWashSwitcherComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/need-a-doctors-note',
    component: NeedADoctorsNoteComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/relieve-outbreak-pain',
    component: RelieveOutbreakPainComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/prevent-vitamin-b12-deficiency',
    component: VitaminB12Component,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/stool-softener',
    component: SofterStoolsComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/azelaic-acid',
    component: AzelaicAcidComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/maximize-your-glp-1-results',
    component: MaximizeYourGlp1ResultsComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/be-prepared-for-the-unexpected',
    component: BePreparedForTheUnexpectedComponent,
    pathMatch: 'full',
    canActivate: [
      ConsultationRequestSessionGuard,
      GenderRestrictedGuard,
      ConsultationUpsellGuard,
      RecentMenstruationRequiredGuard,
    ],
  },
  {
    path: 'consultation/vaginal-cream',
    component: VaginalCreamComponent,
    pathMatch: 'full',
    canActivate: [
      ConsultationRequestSessionGuard,
      GenderRestrictedGuard,
      ConsultationUpsellGuard,
      VaginalCreamAllowedGuard,
    ],
  },
  {
    path: 'consultation/wellness-panel',
    component: WellnessPanelComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/clotrimazole-vaginal-cream',
    component: ClotrimazoleVaginalCreamComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/follow-up-std-test',
    component: FollowUpStdTestComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/payment-info',
    component: ConsultationUpsellPaymentCardComponent,
    pathMatch: 'full',
    canActivate: [
      ConsultationRequestSessionGuard,
      GenderRestrictedGuard,
      ConsultationUpsellGuard,
      ConsultationUpsellPaymentGuard,
    ],
  },
  {
    path: 'consultation/vitamin-d-supplement',
    component: VitaminDSupplementSwitcherComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/zinc-supplement',
    component: ZincSupplementComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/starfish-std/request',
    redirectTo: 'consultation/std/request',
    pathMatch: 'full',
  },
  {
    path: 'consultation/:treatmentType/request',
    component: ConsultationRequestPageComponent,
    resolve: {
      consultationOrderDetails: ConsultationRequestResolver,
    },
    pathMatch: 'full',
  },
  {
    path: 'consultation/submission-error',
    component: ConsultationSubmissionErrorComponent,
    pathMatch: 'full',
  },
  {
    path: 'consultation/navigation-restricted',
    component: ConsultationNavigationRestrictedErrorComponent,
    pathMatch: 'full',
  },
  {
    path: 'consultation/fiber-supplement',
    component: FiberSupplementComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/peptide-therapy',
    component: PeptideTherapySwitcherComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/testosterone-therapy',
    component: TestosteroneTherapyComponent,
    pathMatch: 'full',
    canActivate: [
      ConsultationRequestSessionGuard,
      GenderRestrictedGuard,
      AgeRestrictedUpsellGuard,
      ConsultationUpsellGuard,
    ],
    data: {
      ageRestrictedTreatmentType: ConsultationTreatmentTypes.Trt,
    },
  },
  {
    path: 'consultation/sexual-performance',
    component: SexualPerformanceSwitcherComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard, SkipHasUpsellGuard],
    data: {
      skipHasUpsell: {
        upsellsFromOrder: [UpsellSlugs.EdGiftcard],
      },
    },
  },
  {
    path: 'consultation/biotin',
    component: BiotinComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/hair-growth',
    component: HairGrowthComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/hair-loss-treatment',
    component: HairLossTreatmentComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/metformin',
    component: MetforminSwitcherComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/comprehensive-health-panel',
    component: ComprehensiveHealthPanelComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/expedited-shipping',
    component: ExpeditedShippingComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, GenderRestrictedGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/spf50-sunscreen',
    component: Spf50Sunscreen,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, ConsultationUpsellGuard],
  },
  {
    path: 'consultation/priority-processing',
    component: PriorityProcessingComponent,
    pathMatch: 'full',
    canActivate: [ConsultationRequestSessionGuard, ConsultationUpsellGuard, SkipHasUpsellGuard],
    data: {
      skipHasUpsell: {
        upsellsFromOrder: [UpsellSlugs.PriorityProcessing],
        upsellsFromConsultation: [UpsellSlugs.DeliverMedication],
      },
    },
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'order',
  },
]
  .map(requireCookies)
  .map(requireRouteToBeWhitelisted);

/**
 * Ensures that the WhitelistGuard is added to the route's canActivate array if it is not already
 * present and the route does not redirect to another route.
 *
 * @param {Route} route the original route
 *
 * @returns {Route} the route with the WhitelistGuard added
 */
function requireRouteToBeWhitelisted(route: Route): Route {
  if (!route.redirectTo && !route.canActivate?.includes(WhitelistGuard)) {
    route.canActivate = [WhitelistGuard, ...(route.canActivate || [])];
  }

  return route;
}

/**
 * Makes a route require cookies. If cookies are not enabled, the route's component is replaced with
 * CookiesDisabledComponent. Additionally, any route guards defined in `canActivate` will be removed.
 *
 * @param {any} route the original route
 *
 * @returns {Route} the route with cookies required
 */
function requireCookies(route: any): Route {
  if (navigator.cookieEnabled && isLocalStorageAvailable()) {
    return route;
  }

  if (route.component) {
    route.component = CookiesDisabledComponent;
  }

  if (route.canActivate) {
    route.canActivate = [];
  }

  return route;
}

/**
 * Checks if local storage is available by attempting to set and remove an item.
 *
 * @returns {boolean} true if local storage is available, false otherwise
 */
function isLocalStorageAvailable(): boolean {
  try {
    localStorage.setItem('is-local-storage-available', 'test');
    localStorage.removeItem('is-local-storage-available');

    return true;
  } catch (error) {
    return false;
  }
}

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})

/**
 * Exports the whole application routing module.
 */
export class AppRoutingModule {}
